<div class="wrapper--spacing-horizontal print-only">
  <div class="avoid-page-break" *ngrxLet="customer$ as customer">
    @if (customer) {
      <agr-value-row [label]="reportForLabel | translate" class="customer">{{ customer.name }} </agr-value-row>
      <agr-value-row [label]="'report.address' | translate"
        >{{ customer.street }} {{ customer.houseNumber }}
        {{ customer.houseNumberAddition }}
      </agr-value-row>
      <agr-value-row [label]="'report.city' | translate">{{ customer.postalCode }} {{ customer.city }} </agr-value-row>
      <agr-value-row [label]="'report.mobile' | translate">{{ customer.mobileNumber }}</agr-value-row>
      <agr-value-row [label]="'report.telephone' | translate">{{ customer.phoneNumber }}</agr-value-row>
      <agr-value-row [label]="'report.email' | translate">{{ customer.emailAddress }}</agr-value-row>
      <agr-value-row [label]="'report.customerNumber' | translate">{{ customer.externalId }} </agr-value-row>
    }
    <h2 class="text--h5">{{ 'report.contactTitle' | translate }}</h2>
  </div>
</div>
